import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const Pagination = ({
  pageSize,
  setPageSize,
  pageOptions,
  pageCount,
  canPreviousPage,
  previousPage,
  canNextPage,
  nextPage,
  gotoPage,
  pageIndex
}) => {
  const { t } = useTranslation();

  if (pageCount > 1) {
    return (
      <div className='table-paging'>
        <div>
          <select
            value={pageSize}
            aria-label='Select page size'
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              window.localStorage.setItem('pageSize', JSON.stringify(e.target.value));
            }}>
            {[10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
        <div className='pagination-count'>{`${t('page')} ${pageIndex + 1} ${t('of')} ${pageCount}`}</div>
        <div>
          <button
            key={'first-page'}
            className='page-number'
            disabled={!canPreviousPage}
            onClick={() => gotoPage(0)}>
            {t('first')}
          </button>
          <button
            key={'previous-page'}
            className='page-number'
            disabled={!canPreviousPage}
            onClick={() => previousPage()}>
            {t('back')}
          </button>
          {pageOptions
            .filter((index) => index > pageIndex - 3 && index < pageIndex + 3)
            .map((index) => (
              <button
                key={'page-' + index}
                className='page-number'
                disabled={index === pageIndex}
                onClick={() => gotoPage(index)}>
                {index + 1}
              </button>
            ))}
          <button
            key={'next-page'}
            className='page-number'
            disabled={!canNextPage}
            onClick={() => nextPage()}>
            {t('next')}
          </button>
          <button
            key={'last-page'}
            className='page-number'
            disabled={!canNextPage}
            onClick={() => gotoPage(pageCount - 1)}>
            {t('last')}
          </button>
        </div>
      </div>
    );
  }
};

Pagination.propTypes = {
  length: PropTypes.number,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  pageOptions: PropTypes.array,
  pageCount: PropTypes.number,
  canPreviousPage: PropTypes.bool,
  previousPage: PropTypes.func,
  canNextPage: PropTypes.bool,
  nextPage: PropTypes.func,
  gotoPage: PropTypes.func,
  pageIndex: PropTypes.number
};

export default Pagination;
